import { Component, OnInit } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { AppService } from 'app/app.service';
import { TextSizeService } from '@shared/services/text-size.service';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { FlightdetailService } from 'app/features/flights/flight-detail/service/flightdetail.service';
import { map, Observable, of, switchMap } from 'rxjs';
import { CrewDetail } from 'app/features/flights/flight-detail/model/crew-detail';
import { SignalsService } from '@shared/services/signals/signals.service';
import { AdminService } from 'app/features/admin/admin.service';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-navbar',
    imports: [
        CommonModule,
        MenubarModule,
        ButtonModule,
        MenuModule
    ],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavBarComponent implements OnInit {

  constructor(
    public appService: AppService,
    private textSizeService: TextSizeService,
    private oidcService: OidcSecurityService,
    private flightDetailsService: FlightdetailService,
    private signalsService: SignalsService,
    private adminService: AdminService
  ) {
  }

  //Browser Theme Switcher only
  themeSwitcher: boolean = false;
  navbarSize$ = this.textSizeService.navbarSize$;
  items: MenuItem[] = [];
  activeEmpNumDetails$?: Observable<CrewDetail>;

  ngOnInit(): void {

    this.activeEmpNumDetails$ = this.signalsService.authEmployeeNumber$
      .pipe(
        switchMap((empNum) => {
          const cacheId = `member.loggedin`;
          if (!empNum) {
            const emptyUser: CrewDetail = {
              username: '',
              firstName: '',
              lastName: 'unknown',
              middleName: '',
              nickName: '',
              seat: ''
            }
            this.loadMenuItems(emptyUser);
            return of(emptyUser);
          }
          return this.flightDetailsService.getCrewDetailsFor([empNum], cacheId).pipe(
            map((response) => {
              if (!response || !response.response) {
                const emptyUser: CrewDetail = {
                  username: '',
                  firstName: '',
                  lastName: 'unknown',
                  middleName: '',
                  nickName: '',
                  seat: ''
                }
                //
                this.loadMenuItems(emptyUser);
                return emptyUser;
              }
              this.loadMenuItems(response.response[0]);
              return response.response[0]
            })
          );
        })
      )
  }

  getUserDisplayName(crewDetail: CrewDetail): string {
    const hour = DateTime.now().hour;
    //console.log('Current hour:', hour, 'DateTime:', DateTime.now().toString());
    let greeting = '';
    if (hour < 12) {
      greeting = 'Good Morning';
    } else if (hour < 18) {
      greeting = 'Good Afternoon';
    } else {
      greeting = 'Good Evening';
    }

    if (crewDetail.firstName || crewDetail.nickName) {
      return `${greeting}, ${crewDetail.nickName ? crewDetail.nickName : crewDetail.firstName}`;
    }
    return `${greeting}, User`;
  }

  loadMenuItems(empDetails?: CrewDetail): void {
    this.items = [
      {
        label: 'Options',
        items: [
          {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => this.logout()
          },
          {
            label: 'Theme',
            icon: 'pi pi-moon',
            command: () => this.toggleTheme()
          }
        ]
      }
    ]
  }

  toggleTheme() {
    this.appService.toggleTheme();
  }

  //logout and clear
  logout(): void {
    this.oidcService.logoff().subscribe((_) => {
      this.adminService.clearAllStorage('browser');
    });
  }

  menuButton = {
    colorScheme: {
      light: {
        root: {
          primary: {
            background: 'transparent',
            hoverBackground: 'transparent',
            activeBackground: 'transparent',
            borderColor: 'transparent',
            hoverBorderColor: 'transparent',
            activeBorderColor: 'transparent',
            color: '#e7e7e7'
          }
        }
      }
    }
  }

  menuPanel = {
    root: {
      background: '{surface-100}',
    },
    list: {
      padding: '6px 12px',
      gap: '6px',
    },
    item: {
      focusBackground: 'tranparent',
    },
    submenuLabel: {
      color: '{primary-600}',
    }
  }

}
